import { render, staticRenderFns } from "./PaymentMethodPanel.vue?vue&type=template&id=db2c2bb4&scoped=true&"
import script from "./PaymentMethodPanel.vue?vue&type=script&lang=js&"
export * from "./PaymentMethodPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db2c2bb4",
  null
  
)

export default component.exports